import { ControlledInput } from '@/components/controlled';
import { useFormContext } from 'react-hook-form';
import { LabelRequired } from '@/components/hoc';
import { nameof } from '@/functions';
import { TFormData } from '.';

const FormSearchUserBody = () => {

  const { control, formState: { isSubmitting } } = useFormContext<TFormData>();

  return (
    <div className='py-3 space-y-4'>
      <div className='flex flex-col gap-2'>
        <LabelRequired>
          Email
        </LabelRequired>
        <ControlledInput
          disabled={isSubmitting}
          control={control}
          rules={{ required: 'Requis' }}
          name={nameof<TFormData>('email')}
          placeholder={`Email de l'utilisateur`} />
      </div>
    </div>
  );

};

export default FormSearchUserBody;
